import { defineComponent as _defineComponent } from 'vue'
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import { ref } from 'vue';

interface Variable {
  field: string;
  name?: string;
  value: any;
}

interface Props {
  title?: string;
  variables: Variable[];
  showMore?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcPreviewCardList.ts',
  props: {
    title: { default: '' },
    variables: { default: () => [] },
    showMore: { type: Boolean, default: false }
  },
  emits: ["update"],
  setup(__props: any, { emit: emits }: { emit: ({ (e: 'update', value: boolean): void }), expose: any, slots: any, attrs: any }) {





const opened = ref(false);

function onShowMoreClick() {
  opened.value = !opened.value;

  emits('update', opened.value);
}

return { __sfc: true,emits, opened, onShowMoreClick, CcIcon }
}

})